import { AGENT_ATTACHMENTS_ENABLED_FROM } from '../settings';

export const isAgentFeatureEnabled = (
  agentCreatedAt: Date | string | undefined
): boolean => {
  const cutoffDateString = AGENT_ATTACHMENTS_ENABLED_FROM;

  // If env var is missing, default to false (safe)
  if (!cutoffDateString) return false; 
  if (!agentCreatedAt) return false;

  const cutoffDate = new Date(cutoffDateString);
  const agentDate = new Date(agentCreatedAt);

  // Check if dates are valid
  if (isNaN(cutoffDate.getTime()) || isNaN(agentDate.getTime())) {
    return false;
  }

  // Show feature only if agent was created AFTER the cutoff date
  return agentDate > cutoffDate;
};
